import clsx from "clsx"
import { IconName } from "icons/build"
import { forwardRef, HTMLProps, ReactNode, useRef } from "react"

import { Icon } from "../Icon"
import cls from "./Radio.module.scss"

type RadioProps = HTMLProps<HTMLInputElement> & {
  id: string
  color?: "primary" | "success" | "alert"
  className?: string
  children?: ReactNode
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ color = "primary", id, children, className, ...props }, ref) => {
    return (
      <div className={clsx(cls.radioInput, cls[color])}>
        <input id={id} type="radio" className={cls.input} ref={ref} {...props} />
        <label htmlFor={id} className={clsx(cls.label, className)}>
          <div className={cls.box}>
            <div className={cls.dot} />
          </div>
          {children}
        </label>
      </div>
    )
  }
)

type RadioInputsProps = {
  children: React.ReactNode
  className?: string
}

export const RadioInputs = ({ children, className }: RadioInputsProps) => {
  return <div className={clsx(cls.wrapper, className)}>{children}</div>
}

export const RadioButtonGroup = ({ children, className }: RadioInputsProps) => {
  return <div className={clsx(cls.radioButtonGroup, className)}>{children}</div>
}

type RadioButtonProps = RadioProps & {
  iconName: IconName
}

export const RadioButton = ({ color = "primary", id, children, iconName, checked, ...props }: RadioButtonProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  return (
    <div
      className={clsx(cls.radioButton, checked && cls[`checked-${color}`])} // TODO
      onClick={() => inputRef.current?.click()}
    >
      {/* @ts-expect-error */}
      <Radio ref={inputRef} id={id} checked={checked} color={color} {...props}>
        {children}
      </Radio>
      <Icon name={iconName} size="extra-large" color={checked ? color : "muted"} />
    </div>
  )
}
